export default __webpack_public_path__ + "static/media/logo-hat.4228a27a.png";